import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { Phone, ArrowRight, ArrowLeft } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import { servicePages, site } from '../mock/mock';

export default function ServicePage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, '');
  useReveal([slug]);
  const data = servicePages[slug];
  if (!data) return <Navigate to="/" replace />;

  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="relative h-[52vh] min-h-[380px] overflow-hidden">
        <img src={data.hero} alt={data.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 to-black/65" />
        <div className="relative h-full flex flex-col items-center justify-center text-center px-5">
          <span className="eyebrow text-white/90 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-5 py-2 mb-5">
            {data.eyebrow}
          </span>
          <h1 className="text-white font-serif text-4xl md:text-6xl font-bold drop-shadow-lg max-w-3xl">{data.title}</h1>
          <p className="text-white/90 mt-4 max-w-2xl text-lg drop-shadow">{data.lead}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24">
        <div className="max-w-3xl mx-auto px-5">
          {data.sections.map((s, i) => (
            <div key={i} className="mb-12 reveal">
              <h2 className="text-3xl font-serif font-bold text-ink mb-4">{s.heading}</h2>
              <p className="text-ink/70 leading-loose">{s.body}</p>
            </div>
          ))}

          <div className="bg-cream rounded-2xl p-8 text-center mt-4 reveal">
            <p className="text-ink/75 mb-6">
              To book an appointment or discuss treatment options for your animal, please get in touch.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={site.phoneHref} className="inline-flex items-center justify-center gap-2 bg-sage-500 hover:bg-sage-600 text-white font-semibold px-7 py-3.5 rounded-full transition-all hover:-translate-y-0.5 hover:shadow-lg">
                <Phone size={18} /> Call {site.phone}
              </a>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 border-2 border-sage-500 text-sage-600 hover:bg-sage-500 hover:text-white font-semibold px-7 py-3.5 rounded-full transition-all">
                Contact Us <ArrowRight size={18} />
              </Link>
            </div>
          </div>

          <div className="text-center mt-10">
            <Link to="/" className="inline-flex items-center gap-2 text-sage-600 font-semibold hover:gap-3 transition-all">
              <ArrowLeft size={18} /> Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
